import { Hero } from '../components/Hero';
import { InfoCard } from '../components/InfoCard';
import { Reveal } from '../components/Reveal';

const activities = [
  {
    title: 'Voetbal',
    description:
      'Op het voetbalveld spelen we elke zondagmiddag een voetbaltoernooi. Iedereen is welkom om mee te spelen. We streven ernaar om tijdens het spelen naar elkaar om te zien en op een liefdevolle manier met elkaar te voetballen.',
    imageSrc: '/images/activity-1.jpg',
  },
  {
    title: 'Dans',
    description:
      'Elke zondag is er de mogelijkheid om een toffe dans te leren. Deze dans is vaak op een christelijk hiphopliedje. Aan het eind van de middag wordt de dans eventueel opgevoerd voor de rest van de kinderen en tieners.',
    imageSrc: '/images/activity-3.jpg',
  },
  {
    title: 'Spelletjes',
    description:
      'Tijdens het programma zijn er spelletjes naast het veld. Vaak komen de jongere kinderen hier op af, maar als je zin hebt om mee te doen of als je moet wachten op je volgende potje mag je natuurlijk ook meedoen.',
    imageSrc: '/images/activity-2.jpg',
  },
];

const contactItems = [
  {
    label: 'Email',
    value: 'sc.restarttenboer@gmail.com',
    href: 'mailto:sc.restarttenboer@gmail.com',
  },
  {
    label: 'Locatie',
    value: 'Reigerstraat / Kievitstraat — Panna Kooi (naast oude school), Ten Boer',
  },
  {
    label: 'Instagram',
    value: '@sportcommunity_restart_tenboer',
    href: 'https://www.instagram.com/sportcommunity_restart_tenboer/',
  },
];

export const TenBoerPage = () => {
  return (
    <>
      <Hero
        title="Ten Boer"
        description="Wij zijn elke zondag aanwezig van 14:30 tot 16:00. Voel je vrij om even te kijken bij het veld. Iedereen is welkom."
        imageSrc="/images/hero-tenboer.jpg"
        overlay={false}
        fullHeight
        eyebrow="Locatie · Ten Boer"
      />

      {/* Programma */}
      <section className="py-28 md:py-36 px-6 sm:px-10 md:px-16 bg-[#0D0A00] relative overflow-hidden">
        <div
          className="absolute -top-40 -left-40 w-[480px] h-[480px] rounded-full opacity-[0.07] blur-3xl pointer-events-none"
          style={{ background: '#F5B800' }}
        />
        <div className="container mx-auto max-w-6xl relative">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
            <div className="md:col-span-5">
              <span className="eyebrow text-white/55">Elke zondag · 14:30—16:00</span>
            </div>
            <div className="md:col-span-7">
              <h2 className="text-white text-[40px] md:text-[52px] font-medium tracking-[-0.03em] leading-[1.03]">
                Ons programma —{' '}
                <span className="font-serif-display italic font-normal text-[#F5B800]">eenvoudig en open.</span>
              </h2>
              <p className="mt-6 text-white/65 text-[17px] leading-[1.65] max-w-[58ch]">
                Voel je vrij om even te kijken bij het veld. We maken graag een praatje met je en voor de ouders is er koffie en thee.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mt-16">
            <div className="md:col-span-5">
              <span className="text-white/35 font-mono text-[13px] tracking-wider">PAUZE / 15:15</span>
            </div>
            <div className="md:col-span-7 border-l border-[#F5B800]/30 pl-8">
              <p className="text-white/70 text-[16px] leading-[1.7] max-w-[58ch]">
                In de pauze vertellen wij een bijbelverhaal met daarbij een getuigenis of een toneelstukje. Vervolgens gaan we in onze teams uit elkaar om op een laagdrempelige manier verder te kletsen over het onderwerp. Er is ruimte voor alle vragen en gesprek over het geloof. We sluiten de pauze af door met elkaar te bidden.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Activiteiten */}
      <section className="py-28 md:py-36 px-6 sm:px-10 md:px-16 bg-[#FBFAF6]">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-20 md:mb-28">
            <div className="md:col-span-5">
              <span className="eyebrow text-[#0D0A00]/60">Activiteiten</span>
            </div>
            <div className="md:col-span-7">
              <h2 className="text-[#0D0A00] text-[40px] md:text-[56px] font-medium tracking-[-0.035em] leading-[1.02]">
                Wat je kan doen <br className="hidden md:block" />
                <span className="font-serif-display italic font-normal text-[#0D0A00]/70">op het veld.</span>
              </h2>
            </div>
          </div>

          <div className="flex flex-col gap-24 md:gap-32">
            {activities.map((item, i) => (
              <Reveal key={item.title}>
                <InfoCard {...item} index={i} reverse={i % 2 === 1} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="py-28 md:py-36 px-6 sm:px-10 md:px-16">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
            <div className="lg:col-span-5">
              <span className="eyebrow text-[#0D0A00]/55">Restart Ten Boer</span>
              <h2 className="mt-6 text-[#0D0A00] text-[40px] md:text-[52px] font-medium tracking-[-0.03em] leading-[1.03]">
                Kom langs of{' '}
                <span className="font-serif-display italic font-normal text-[#0D0A00]/70">stuur ons een bericht.</span>
              </h2>
              <p className="mt-6 text-[#0D0A00]/60 text-[16.5px] leading-[1.65] max-w-[42ch]">
                Heb je interesse of vragen? Kom naar het veld toe voor een praatje, of bereik ons via de mail of Instagram.
              </p>
              <div className="mt-10 flex flex-wrap gap-3">
                <a
                  href="mailto:sc.restarttenboer@gmail.com"
                  className="btn-pill"
                  style={{ background: '#0D0A00', color: '#fff' }}
                >
                  Mail ons
                  <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6H10M10 6L6 2M10 6L6 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </a>
                <a
                  href="https://maps.google.com/?q=Reigerstraat+Kievitstraat+Ten+Boer"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-pill"
                  style={{ background: 'transparent', color: '#0D0A00', border: '1px solid rgba(13,10,0,0.18)' }}
                >
                  Route
                </a>
              </div>
            </div>

            <div className="lg:col-span-7 flex flex-col divide-y divide-[#0D0A00]/8">
              {contactItems.map(({ label, value, href }) => (
                <div key={label} className="grid grid-cols-12 gap-4 items-baseline py-6 first:pt-0">
                  <span className="col-span-4 text-[#0D0A00]/40 font-mono text-[12px] tracking-wider uppercase">
                    {label}
                  </span>
                  <span className="col-span-8 text-[#0D0A00] text-[17px]">
                    {href ? (
                      <a
                        href={href}
                        target={href.startsWith('http') ? '_blank' : undefined}
                        rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
                        className="hover:text-[#0F4DF9] transition-colors"
                      >
                        {value}
                      </a>
                    ) : (
                      value
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Map */}
          <div className="mt-16 h-[420px] md:h-[500px] rounded-[20px] overflow-hidden border border-[#0D0A00]/8 shadow-[0_20px_50px_-20px_rgba(13,10,0,0.18)]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d792.5469967670009!2d6.6880171!3d53.2763402!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c9d34e151260eb%3A0x8ac9345f9f1fe0db!2sSportcommunity%20Restart!5e1!3m2!1snl!2snl!4v1749199215061!5m2!1snl!2snl"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ten Boer kaart"
            />
          </div>
        </div>
      </section>
    </>
  );
};
